/**
 * @file Alerts component
 * @author Heino Lenting
 */
import { AlertsService } from '../alerts.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SettingsService } from '../../settings.service';
/**
 * Class for the alerts component
 */
var AlertsComponent = /** @class */ (function () {
    /**
     * Constructs an AlertsComponent
     */
    function AlertsComponent(alertsService, translateService, settingsService) {
        this.alertsService = alertsService;
        this.translateService = translateService;
        this.settingsService = settingsService;
    }
    /**
     * Create a custom support link per alert (to add details/errors etc)
     * @param id The id of the alert
     * @returns An url with URL encoded data
     */
    AlertsComponent.prototype.createSupportLink = function (id) {
        // PEFORMANCE: createSupportLink is called four times for rendering of the mailto
        // link. Can be optimized by saving the generate mailto link per alert.
        var alert = this.alertsService.getAlert(id);
        var to = this.settingsService.settings.frontend.support.mail;
        var subject = this.translateService.instant('APP.ALERTS.SUPPORT_HEADER', { variant: alert.variant });
        var body;
        body = this.translateService.instant('APP.ALERTS.DESCRIBE_ISSUE');
        body += '\n\n\n\n';
        body += '---------- ' + this.translateService.instant('APP.ALERTS.BROWSER_DETAILS') + ': ----------\n';
        body += this.translateService.instant('APP.ALERTS.BROWSER_CODENAME') + ': ' + navigator.appCodeName + '\n';
        body += this.translateService.instant('APP.ALERTS.BROWSER_NAME') + ': ' + navigator.appName + '\n';
        body += this.translateService.instant('APP.ALERTS.BROWSER_VERSION') + ': ' + navigator.appVersion + '\n';
        body += this.translateService.instant('APP.ALERTS.COOKIES_ENABLED') + ': ' + navigator.cookieEnabled + '\n';
        body += this.translateService.instant('APP.ALERTS.PLATFORM') + ': ' + navigator.platform + '\n';
        body += this.translateService.instant('APP.ALERTS.USER_AGENT_HEADER') + ': ' + navigator.userAgent + '\n';
        body += this.translateService.instant('APP.ALERTS.USER_AGENT_LANGUAGE') + ': ' + navigator.language + '\n';
        body += '\n';
        body += '---------- ' + this.translateService.instant('APP.ALERTS.APPLICATION_DETAILS') + ': ----------\n';
        body += 'URL: ' + window.location + '\n';
        body += 'Front-end: ' + this.settingsService.settings.frontend.version + '\n';
        body += '\n';
        // Only add labelKey if available
        if (alert && alert.labelKey) {
            body += '---------- ' + this.translateService.instant('APP.ALERTS.ALERT_MESSAGE') + ': ----------\n';
            body += this.translateService.instant(alert.labelKey) + '\n';
            body += '\n';
        }
        // Only add details if available
        if (alert && alert.details) {
            body += '---------- ' + this.translateService.instant('APP.ALERTS.ALERT_DETAILS') + ': ----------\n';
            body += this.getDetailText(alert.details);
            body += '\n\n';
        }
        var link = 'mailto:' + to + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
        return link;
    };
    /**
     * Converts details object of alert to text.
     * @private
     * @param {*} details Details object of alert.
     * @returns {string} Text representation of detail object.
     */
    AlertsComponent.prototype.getDetailText = function (details) {
        var _this = this;
        if (details == null) {
            return '';
        }
        if (details instanceof Array) {
            var result_1 = '';
            var items = details;
            items.forEach(function (item) {
                if (item) {
                    result_1 += _this.translateService.instant(item) + '\n';
                }
            });
            return result_1;
        }
        if (details instanceof HttpErrorResponse) {
            var response = details;
            if (response.error && response.error['$type'] === 'Symagic.Core.Server.ErrorResponse, Symagic.Core.Server') {
                return this.translateService.instant(response.error['label']);
            }
            return 'Status: ' + response.status + '\n' + response.message + '\n' + response.statusText;
        }
        if (details['$type'] === 'Symagic.Core.Server.ErrorResponse, Symagic.Core.Server') {
            return this.translateService.instant(details['label']);
        }
        if (details instanceof Error) {
            var error = details;
            return error.message;
        }
        return details;
    };
    return AlertsComponent;
}());
export { AlertsComponent };
